import {Divider} from "./polaris/divider"
import feature_move_money from "../assets/feature-move-money.png"
import cover_money from "../assets/cover-money.png"
import beach from "../assets/beach.png"
import personal_finance from "../assets/personal-finance.jpg"
import financial_freedom from "../assets/financial-freedom.jpg"
function PayLater() {

    return (
        <>
            <div className="min-h-screen flex">
                <div className="self-center mx-auto p-4">
                    <section className="max-w-[800px] container mx-auto px-2 lg:px-0 w-full mb-10">
                        <div className="p-0 gap-4 rounded-2xl grid grid-cols-1 lg:flex w-full">
                            <div className="w-full grid grid-cols-2">
                                <div className="text-center h-[400px] flex relative bg-[#2774ae] rounded-l-xl">
                                    <div className="self-center mx-auto relative">
                                        <div className="my-3 h-[3px] w-[30px] mx-auto rounded-lg" style={{
                                            background: 'linear-gradient(to right, #f32170,#ff6b08, #cf23cf)',
                                        }}/>
                                        <ul className="text-sm text-left text-white px-4 space-y-2">
                                            <li>
                                                Tặng cường lực Kingkong xịn
                                            </li>
                                            <li>
                                                Tặng google drive Premium 50GB
                                            </li>
                                            <li>
                                                Tặng youtube premium ko quảng cáo
                                            </li>
                                        </ul>
                                        <div className="my-3 h-[3px] w-[30px] mx-auto rounded-lg" style={{
                                            background: 'linear-gradient(to right, #f32170,#ff6b08, #cf23cf)',
                                        }}/>
                                    </div>
                                </div>

                                <div className=" text-center h-[400px] flex relative">
                                    <div 
                                        className="absolute top-0 left-0 w-full h-[400px] rounded-r-xl"
                                        style={{
                                        background: `url(${beach}) no-repeat center`,
                                        backgroundSize: "cover",
                                        filter: "blur(0px)", // Áp dụng mờ cho ảnh nền
                                        zIndex: 0, // Đảm bảo ảnh nền nằm dưới văn bản
                                        }}
                                    ></div>
                                    <div className="self-center mx-auto relative text-white">
                                        <span className="font-bold text-2xl lg:text-4xl w-full">
                                            <span className="text-5xl lg:text-6xl">Ưu đãi</span> 
                                            <br/>Vay trên 
                                            <br/>4 tháng</span>
                                    </div>
                                </div>

                            </div>

                        </div>
                        
                    </section>

                    <section className="max-w-[800px] container mx-auto px-2 lg:px-0 w-full mb-6">
                        <div className="p-0 gap-4 rounded-2xl grid grid-cols-1 lg:flex w-full">

                            <div className="px-2 text-center h-[400px] w-full lg:w-1/2 grid grid-cols-1 lg:flex relative rounded-xl"
                                style={{
                                    background: 'linear-gradient(259deg, #a5ffd4 .33%, #59cdff)'
                                }}>
                                <div className="self-center mx-auto relative">
                                <img className="max-w-[180px] rounded-lg mx-auto grid grid-cols-1" style={{marginTop:"-50px"}} src="https://liobank.vn/img/pig/first_block/phone.svg" />
                                    <span className="text-md font-bold">Đặc quyền miễn lãi</span> <br/>
                                    <span className="text-md">Với các khách hàng đã vay và trả đúng hạn</span>
                                    <div className="my-3 h-[3px] w-[30px] mx-auto rounded-lg" style={{
                                            background: 'linear-gradient(to right, #f32170,#ff6b08, #cf23cf)',
                                        }}/>
                                </div>
                            </div>

                            <div className="w-full lg:w-1/2 grid grid-cols-1 text-white">

                                <div className=" text-center h-[400px] flex relative">
                                    <div 
                                        className="hidden md:block absolute top-[-80px] left-0 w-full h-[400px] rounded-lg"
                                        style={{
                                        background: "url(https://liobank.vn/img/pig/second_block/gradient_2.svg) no-repeat center",
                                        // backgroundPosition:"center",
                                        backgroundSize: "contain",
                                        filter: "blur(0px)", // Áp dụng mờ cho ảnh nền
                                        zIndex: 0, // Đảm bảo ảnh nền nằm dưới văn bản
                                        }}
                                    ></div>
                                    <div 
                                        className="hidden md:block absolute top-[50px] left-[-50px] w-full h-[400px] rounded-lg"
                                        style={{
                                        background: "url(https://liobank.vn/img/pig/second_block/gradient_1.svg) no-repeat center",
                                        // backgroundPosition:"center",
                                        backgroundSize: "contain",
                                        filter: "blur(0px)", // Áp dụng mờ cho ảnh nền
                                        zIndex: 0, // Đảm bảo ảnh nền nằm dưới văn bản
                                        }}
                                    ></div>
                                    <div 
                                        className="hidden md:block absolute top-[80px] left-[80px] w-full h-[400px] rounded-lg"
                                        style={{
                                        background: "url(https://liobank.vn/img/pig/second_block/gradient_3.svg) no-repeat center",
                                        // backgroundPosition:"center",
                                        backgroundSize: "contain",
                                        filter: "blur(0px)", // Áp dụng mờ cho ảnh nền
                                        zIndex: 0, // Đảm bảo ảnh nền nằm dưới văn bản
                                        }}
                                    ></div>
                                    <div className="self-center mx-auto relative grid grid-cols-1 py-6 px-10 rounded-lg">
                                        <span className="text-xs px-4">Với các khoản thanh toán hộ</span>
                                        <span className="text-xs px-4">Hỗ trợ lên đến </span>
                                        <Divider/>
                                        <span className="font-bold text-2xl lg:text-4xl w-full">
                                            <span className="text-5xl lg:text-6xl" style={{
                                                background: 'linear-gradient(to right, #f32170,#ff6b08, #cf23cf, #eedd44)',
                                                WebkitBackgroundClip: 'text',
                                                WebkitTextFillColor: 'transparent'
                                            }}>3.000.000</span> 
                                        </span>
                                        <span className="font-bold text-xl w-full">
                                            <span className="text-5xl lg:text-6xl" style={{
                                                background: 'linear-gradient(to right, #f32170,#ff6b08, #cf23cf, #eedd44)',
                                                WebkitBackgroundClip: 'text',
                                                WebkitTextFillColor: 'transparent'
                                            }}>vnd</span> 
                                        </span>
                                        <span className="text-xs px-4">Tất toán vào ngày 30 mỗi tháng. Nghĩa là mượn vào ngày nào đó trong tháng, nhưng cần tất toán trước ngày 30 </span>
                                        <Divider/>
                                        <span className="text-lg font-bold px-4">Lãi suất 0%</span>
                                    </div>
                                </div>

                            </div>

                        </div>
                        
                    </section>

                </div>
            </div>

        </>
    );
}
export default PayLater;